import { PRODUCT_TEMPLATES } from 'shared/consts/productTemplates'

export const shouldRenderLabel = ({
  productTemplate,
  redPointsMultiplierIsValid,
  redPointsIsActive,
  redPoints,
  multiplierRP,
}) =>
  productTemplate !== PRODUCT_TEMPLATES.RX &&
  redPointsMultiplierIsValid &&
  redPointsIsActive &&
  multiplierRP > 1 &&
  redPoints > 0

export const shouldRenderBadge = ({
  productTemplate = null,
  redPointsIsActive = false,
  redPoints = 0,
  multiplierRP = 1,
}) =>
  productTemplate !== PRODUCT_TEMPLATES.RX &&
  redPointsIsActive &&
  redPoints > 0 &&
  multiplierRP > 0

export const getMultipliedRedPoints = ({
  redPointsMultiplierIsValid,
  multiplierRP,
  redPoints,
}) => {
  const multiplier = redPointsMultiplierIsValid ? multiplierRP : 1

  return multiplier * redPoints
}
